export const APP_INSTALL_HANDLER = "APP_INSTALL_HANDLER";
export const APP_PROMPT_INSTALL_SHOW = "APP_PROMPT_INSTALL_SHOW";
